import { mapState } from 'vuex';

export const AppsData = {
	computed: mapState({
		departments: state => state.appsData.data.departments,
		phone: state => state.appsData.data.phone,
		mail: state => state.appsData.data.mail,
		facebook: state => state.appsData.data.facebook,
		linkedin: state => state.appsData.data.linkedin,
		instagram: state => state.appsData.data.instagram,
		employeesPage: state => state.appsData.data.employeesPage,
		cookiePrivacyPage: state => state.appsData.data.cookiePrivacyPage,
		contactPage: state => state.appsData.data.contactPage,
		openingHoursPage: state => state.appsData.data.openingHoursPage,
		website: state => state.appsData.data.website,
	}),
};


// WEBPACK FOOTER //
// ./assets/_js/mixins/apps-data.js